import { useEffect, useState } from 'react';

/**
 * True once `active` has stayed true for `delayMs`; false again the moment it isn't. For loading states that
 * shouldn't flash when the answer comes back quickly.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const timer = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);
  return active && shown;
}
